export const BROWSER_NOT_SUPPORTED_MESSAGE =
  'Internet Explorer is not supported in the New Report Center. ' +
  'Please use one of the following browsers to access the New Report Center: Google Chrome, Mozilla Firefox, or Microsoft Edge.';
